exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Loading_preloader_1inv {\n  position: static;\n\n  -webkit-transform: none;\n\n          transform: none;\n}\n", ""]);

// exports
exports.locals = {
	"preloader": "Loading_preloader_1inv"
};